<template>
  <div>
    <!--    <h3>Add User</h3>-->
    <section>
      <div class="form-inline">
        <label for="email">Email:</label>
        <div>
          <input
            name="email"
            id="email"
            type="text"
            placeholder="Email"
            v-model="editEmail"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="password">Password:</label>
        <div>
          <input
            name="password"
            id="password"
            type="text"
            placeholder="Password"
            v-model="editPassword"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="sendEmail">Send Email:</label>
        <div>
          <model-select
            :options="sendEmailOptions"
            v-model="editSendEmail"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add User</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  components: {
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      editEmail: null,
      editPassword: null,
      editSendEmail: null,
      sendEmailOptions: [
        { value: true, text: "yes" },
        { value: false, text: "no" },
      ],
    };
  },
  methods: {
    buttonClick: function () {
      if (this.editPassword && this.editPassword.length < 8) {
        this.$toasted.global.toast_error({
          message: "please use at least 8 characters for the password",
        });
        return;
      }
      this.$emit("closePanel");
      this.$emit(
        "buttonClick",
        this.editEmail,
        this.editPassword,
        this.editSendEmail
      );
    },
  },
};
</script>
